import { render, staticRenderFns } from "./identifier.vue?vue&type=template&id=7b04b9e0&scoped=true&"
import script from "./identifier.vue?vue&type=script&lang=js&"
export * from "./identifier.vue?vue&type=script&lang=js&"
import style0 from "./identifier.vue?vue&type=style&index=0&id=7b04b9e0&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b04b9e0",
  null
  
)

export default component.exports